import React from 'react';
import NavBar from '../Navbar/NavBar';
import HeaderMain from '../HeaderMain/HeaderMain';


const Header = () => {
    return (
        <div className="shared-container mb-5">
            <NavBar />
            <HeaderMain />
        </div>
    );
};

export default Header;